window.popup=function(name){
    var popupImg=name;
    $(".popup ,.mask").show();
    $(".popup_img img").hide().eq(name).show();
    $(".popup .close").click(function(){
        $(".mask ,.ent ,.popup").hide();
    });
  $(".icon-arrow_left").click(function(){
    $(".popup_img img").stop(true,true);
      if(popupImg>0){
        popupImg--;
        $(".popup_img img").fadeOut().eq(popupImg).fadeIn();
      }
  });
  $(".icon-arrow_right").click(function(){
    $(".popup_img img").stop(true,true);
    if(popupImg<4){
      popupImg++;
      $(".popup_img img").fadeOut().eq(popupImg).fadeIn();
    }
  })
};
window.popupVideo=function(){
  $(".mask,.popup_video").show();
  $(".video_cent").html('<video id="video1" width="800" height="500" autoplay loop controls><source src="https://sres.q1.com/flv/lw2/lw2_zqcf.mp4" type="video/mp4" /></video>');
};
window.popupClose=function(){
  $(".mask ,.ent ,.popup ,.popup_video").hide();
  $(".video_cent").html('')
};

